export default __webpack_public_path__ + "static/media/Group 3224@2x.4f828355.png";